'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { OnboardingApplicationPage } from '../-components/OnboardingApplicationPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-onboarding/applications/')({
  component: OnboardingApplicationPage
});